class FAQItem extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.question = this.querySelector(".faqrs-question");
    this.answer = this.querySelector(".faqrs-answer");
    if (this.question && this.answer) {
      this.question.addEventListener("click", this.handleToggle);
      if (this.hasAttribute("data-faq-open")) {
        requestAnimationFrame(() => this.open());
      }
    }
  }

  disconnectedCallback() {
    if (this.question) {
      this.question.removeEventListener("click", this.handleToggle);
    }
  }

  handleToggle() {
    const isActive = this.classList.contains("faqrs-active");
    const allItems = document.querySelectorAll("faq-item");
    allItems.forEach(item => item.close());
    if (!isActive) {
      this.open();
    }
  }

  open() {
    this.classList.add("faqrs-active");
    this.answer.style.maxHeight = this.answer.scrollHeight + "px";
    this.question.setAttribute("aria-expanded", "true");
  }

  close() {
    this.classList.remove("faqrs-active");
    if (this.answer) {
      this.answer.style.maxHeight = null;
    }
    if (this.question) {
      this.question.setAttribute("aria-expanded", "false");
    }
  }
}
customElements.define("faq-item", FAQItem);


// Mobile menu drawer is handled natively by the theme's header-drawer
// custom element via the theme:drawer:toggle event system.
// No custom override needed here.

/**
 * Sticky Cart-Bar Price Sync for Appstle Subscriptions
 * This script specifically watches the Appstle widget for active price changes
 * and mirrors them to the sticky `cart-bar`.
 */
document.addEventListener('DOMContentLoaded', () => {
  const syncCartBarPriceAppstle = () => {
    const updateCartBar = () => {
      const cartBarPriceContainers = document.querySelectorAll('cart-bar .cart-bar__product__price');
      if (cartBarPriceContainers.length === 0) return;

      // Appstle specific selector for the active option
      const activeOption = document.querySelector('.appstle-active-option');
      if (!activeOption) return;

      const appstleActivePriceElement = activeOption.querySelector('.appstle_subscription_amount');
      const appstleComparePriceElement = activeOption.querySelector('.appstle_subscription_compare_amount, .appstle_subscription_amount_compare_at_price');

      if (appstleActivePriceElement && appstleActivePriceElement.innerHTML) {
        const newPriceHTML = appstleActivePriceElement.innerHTML;
        const newCompareHTML = (appstleComparePriceElement && appstleComparePriceElement.innerHTML.trim() !== '') ? appstleComparePriceElement.innerHTML : null;

        cartBarPriceContainers.forEach(container => {
          // Update main price
          const mainPriceSpan = container.querySelector('[data-product-price]');
          if (mainPriceSpan && mainPriceSpan.innerHTML !== newPriceHTML) {
            mainPriceSpan.innerHTML = newPriceHTML;
          }

          // Update or Hide compare price
          let strikeSpan = container.querySelector('.product__price--strike');
          if (newCompareHTML) {
            if (!strikeSpan) {
              // Create it if it doesn't exist
              strikeSpan = document.createElement('s');
              strikeSpan.className = 'product__price--strike';
              container.appendChild(strikeSpan);
            }
            if (strikeSpan.innerHTML !== newCompareHTML) {
              strikeSpan.innerHTML = newCompareHTML;
            }
            strikeSpan.style.display = 'inline-block';
            strikeSpan.style.marginLeft = '8px'; // Add slight spacing
          } else {
            if (strikeSpan) {
              strikeSpan.style.display = 'none';
              strikeSpan.innerHTML = '';
            }
          }
        });
      }
    };

    // Watch the entire body to ensure we catch Appstle injecting the widget
    // and moving the 'appstle-active-option' class when clicked.
    let rafId;
    const observer = new MutationObserver(() => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        updateCartBar();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'] // Triggers when the active class moves
    });

    // Run a few times on load because Appstle loads asynchronously
    updateCartBar();
    setTimeout(updateCartBar, 1000);
    setTimeout(updateCartBar, 3000);
  };

  syncCartBarPriceAppstle();
});

  if (!customElements.get('custom-bundle-subscription')) {
    customElements.define('custom-bundle-subscription', class CustomBundleSubscription extends HTMLElement {
      constructor() {
        super();
        this.basePrice = parseFloat(this.getAttribute('data-base-price')) || 99.00;
        this.currencySymbol = this.getAttribute('data-currency-symbol') || '$';
        
        this.typeContainers = this.querySelectorAll('.cbs-option-container');
        this.cards = this.querySelectorAll('.cbs-card');
        
        // Headers
        this.onetimePriceHeader = this.querySelector('.cbs-onetime-price-header');
        this.subscribeSubtext = this.querySelector('.cbs-subscribe-subtext');
        this.subscribePriceHeader = this.querySelector('.cbs-subscribe-price-header');
        
        // Delivery text
        this.deliveryTextDisplay = this.querySelector('.cbs-delivery-text-display');
        
        this.bindEvents();
        this.selectType('subscribe');
      }
      
      bindEvents() {
        // Container / Radio clicks
        this.typeContainers.forEach(container => {
          container.addEventListener('click', (e) => {
            const type = container.getAttribute('data-type');
            if (!container.classList.contains('cbs-active')) {
              this.selectType(type);
            }
          });
        });
        
        // Card clicks
        this.cards.forEach(card => {
          card.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevents double firing container click
            const type = card.closest('.cbs-option-container').getAttribute('data-type');
            // Ensure container is active
            if (!card.closest('.cbs-option-container').classList.contains('cbs-active')) {
              this.selectType(type, false);
            }
            this.selectCard(card, type);
          });
        });
      }
      
      selectType(type, resetCard = true) {
        this.typeContainers.forEach(container => {
          const isMatch = container.getAttribute('data-type') === type;
          container.classList.toggle('cbs-active', isMatch);
          container.querySelector('.cbs-radio-input').checked = isMatch;
        });
        
        if (type === 'onetime') {
          this.subscribeSubtext.style.display = 'block';
          this.subscribePriceHeader.style.display = 'none';
          
          if (resetCard) {
            const firstCard = this.querySelector('[data-type="onetime"] .cbs-card');
            if (firstCard) this.selectCard(firstCard, 'onetime');
          }
        } else {
          this.subscribeSubtext.style.display = 'none';
          this.subscribePriceHeader.style.display = 'none';
          
          if (resetCard) {
            const defaultCard = this.querySelector('[data-type="subscribe"] .cbs-card-active') || this.querySelector('[data-type="subscribe"] .cbs-card');
            if (defaultCard) this.selectCard(defaultCard, 'subscribe');
          }
        }
      }
      
      selectCard(cardElement, type) {
        // Handle visual classes
        const container = cardElement.closest('.cbs-option-container');
        container.querySelectorAll('.cbs-card').forEach(c => c.classList.remove('cbs-card-active'));
        cardElement.classList.add('cbs-card-active');
        
        // Get values
        const qtyMultiplier = parseInt(cardElement.getAttribute('data-qty'), 10) || 1;
        const discountPercentage = parseFloat(cardElement.getAttribute('data-discount')) || 0;
        const deliveryText = cardElement.getAttribute('data-delivery');
        
        const pricePerUnit = this.basePrice * (1 - discountPercentage);
        const total = pricePerUnit * qtyMultiplier;
        const totalDays = 30 * qtyMultiplier;
        const perDay = total / totalDays;
        
        // Update local widget UI
        const formatMoney = (val) => this.currencySymbol + val.toFixed(2);
        const priceWrapper = type === 'onetime' ? this.onetimePriceHeader : this.subscribePriceHeader;
        
        const dayEl = priceWrapper.querySelector('.cbs-price-per-day');
        const totalEl = priceWrapper.querySelector('.cbs-price-total');
        if (dayEl) dayEl.innerHTML = formatMoney(perDay) + ' / day';
        if (totalEl) totalEl.innerHTML = formatMoney(total) + ' / total';
        
        if (type === 'subscribe' && this.deliveryTextDisplay && deliveryText) {
          this.deliveryTextDisplay.innerText = deliveryText;
        }
        
        // Update selling plan for Appstle subscription
        const sellingPlanId = (type === 'subscribe') ? (cardElement.getAttribute('data-selling-plan') || '') : '';
        this.updateSellingPlanInput(sellingPlanId);
        
        // Interop with Shopify Native Elements
        this.updateFormQuantity(qtyMultiplier);
        this.updateButtonSave(discountPercentage);
      }
      
    updateSellingPlanInput(sellingPlanId) {
      const forms = document.querySelectorAll('form[action*="/cart/add"], form[data-product-form]');
      forms.forEach(form => {
        let spInput = form.querySelector('input[name="selling_plan"]');
        if (!spInput) {
          spInput = document.createElement('input');
          spInput.type = 'hidden';
          spInput.name = 'selling_plan';
          form.appendChild(spInput);
        }
        spInput.value = sellingPlanId;
        spInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const formAttrInputs = document.querySelectorAll('input[name="selling_plan"][form]');
      formAttrInputs.forEach(input => {
        input.value = sellingPlanId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const url = new URL(window.location.href);
      if (sellingPlanId) {
        url.searchParams.set('selling_plan', sellingPlanId);
      } else {
        url.searchParams.delete('selling_plan');
      }
      window.history.replaceState({}, '', url.toString());

      // Sync with hidden Appstle widget
      const appstleSelect = document.querySelector('.appstle_select');
      const appstleSubRadio = document.querySelector('.appstle_subscription_radio_wrapper input[type="radio"]');
      const appstleOneTimeRadio = document.querySelector('.appstle_one_time_details_wrapper input[type="radio"]');

      if (sellingPlanId) {
        // Subscribe & Save active
        if (appstleSelect) {
          appstleSelect.value = sellingPlanId;
          appstleSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (appstleSubRadio && !appstleSubRadio.checked) {
          appstleSubRadio.click(); // Click triggers Appstle's internal JS better than just setting .checked
        }
      } else {
        // One-time purchase active
        if (appstleOneTimeRadio && !appstleOneTimeRadio.checked) {
          appstleOneTimeRadio.click();
        }
      }

      document.dispatchEvent(new CustomEvent('appstle:selling_plan_change', {
        detail: { selling_plan_id: sellingPlanId }
      }));
      document.dispatchEvent(new CustomEvent('selling_plan:change', {
        bubbles: true,
        detail: { selling_plan: sellingPlanId }
      }));
    }
      updateFormQuantity(qty) {
        // Find the closest native form wrapper or fallback to global document
        const form = document.querySelector('form[action="/cart/add"]');
        if (!form) return;
        
        const qtyInput = form.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
          // Dispatch change event so theme JS catches it
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Some themes use generic inputs outside form using `form="..."`
        const isolatedQtyInputs = document.querySelectorAll('input[name="quantity"]');
        isolatedQtyInputs.forEach(input => {
          if (input.value != qty) {
            input.value = qty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      
      updateButtonSave(discount) {
        // 主 CTA + sticky cart-bar 的按钮后缀都显示「 - SAVE X%」（X = 选中档折扣，跟卡片一致）
        const pct = discount > 0 ? ' - SAVE ' + Math.round(discount * 100) + '%' : '';
        document.querySelectorAll('[data-vv-atc-suffix], [data-cart-bar-save]').forEach((el) => {
          el.innerHTML = pct;
        });
      }

    });
  }


/**
 * One Time Purchase 链接：一键直接加购一次性商品（无 selling_plan = 全价），完成后进购物车。
 * Will 要求点击直接加购（行为 A），而非切换订阅卡 + 改 CTA 价格（旧行为 B）。
 */
document.addEventListener('click', function (e) {
  const link = e.target.closest('[data-vv-one-time]');
  if (!link) return;
  e.preventDefault();
  const variantId = parseInt(link.getAttribute('data-variant-id'), 10);
  if (!variantId) return;
  link.style.opacity = '0.5';
  link.style.pointerEvents = 'none';
  // 用原生表单 POST /cart/add 加购：浏览器整页提交，绕过 Appstle 对 fetch 和 XHR 的双重劫持
  // （二者都会给 /cart/add 强制注入 selling_plan，把一次性变成订阅）。原生表单加纯一次性
  // 全价商品，Shopify 默认重定向到 /cart 购物车页（不是 checkout）。
  // 已实测：cart 行 selling_plan_allocation=null、全价无折扣。
  var form = document.createElement('form');
  form.method = 'POST';
  form.action = '/cart/add';
  form.innerHTML = '<input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1">';
  document.body.appendChild(form);
  form.submit();
});


